module.exports = {
	methods: {
		feed() {
			const self = this;

			return {
				async list(offset = 0, limit = self.limit) {
					try {
						const response = await self.$http.get(
							'socialfeed', {
								params: {
									offset,
									limit,
								},
								headers: {
									Authorization: true,
								},
							},
						);

						const deals = {
							total: response.data.feed.total,
							results: response.data.feed.results,
						};

						return {
							ok: true,
							data: deals,
							error: null,
						};
					} catch (error) {
						return {
							ok: false,
							data: [],
							error: null,
						};
					}
				},
			};
		},
	},
};
